var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 617",
    style: {
      enableBackground: "new 0 0 490 617"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#717171;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.7,259.1l-128,128c-35.4,35.4-92.6,35.4-128,0l-19-19l44-41.4l17.7,17.7c11.9,11.8,30.9,11.8,42.7,0 L402,216.5c11.8-11.9,11.8-30.9,0-42.7l-21.4-21.4c-11.8-11.8-30.8-11.8-42.7,0L312,178.3c-24.7-13.8-54.2-15.7-80.1-5.2l63.3-63.3 c35.4-35.4,92.6-35.4,128,0l21.4,21.4C480,166.5,480,223.7,444.7,259.1z M178,439.2l-25.9,25.9c-11.8,11.8-30.9,11.8-42.7,0 L88,443.8c-11.8-11.8-11.8-30.8,0-42.7l128-127.9c11.8-11.8,30.8-11.8,42.7,0l17.7,17.7l44-41.4l-19-19c-35.4-35.4-92.6-35.4-128,0 l-128.1,128c-35.4,35.4-35.4,92.6,0,128l21.4,21.4c35.4,35.4,92.6,35.4,128,0l63.3-63.3C232.2,455,202.7,453,178,439.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.13ac542170066e2b0decb9cf870a136d.svg";
export { ForwardRef as ReactComponent };